// Copied byte for byte into admin-panel/src/ui/hooks, which shares no package
// with client; client's useManagedPolling.mirror.spec.ts fails on any drift.
import { useEffect, useState } from 'react';

export const useTabActivity = (): boolean => {
  const [isTabActive, setIsTabActive] = useState(!document.hidden);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsTabActive(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isTabActive;
};
